import { callForHelpStore } from "../stores/call-for-help.store";

export const useCallForHelpStore = () => callForHelpStore;
